import React from 'react'

const CheckBox = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='13' height='10' viewBox='0 0 13 10' fill='none'>
      <path
        d='M4.16897 9.07473L0.113281 5.03995L1.17947 3.95286L4.16897 6.94236L10.9633 0.168945L12.0295 1.23513L4.16897 9.07473Z'
        fill='#095BBD'
      />
    </svg>
  )
}

export default CheckBox
